/**
 * `data-test` ids for the planner UI, so e2e tests do not depend on layout or copy.
 * A chip has the same id wherever it renders: tests care about the chips on screen,
 * not which component drew them.
 */
export const PLANNER_TEST_IDS = {
  composer: 'planner-composer',
  composerCount: 'planner-composer-count',
  send: 'planner-send',
  errorRetry: 'planner-error-retry',
  errorEdit: 'planner-error-edit',
  chip: 'planner-chip',
  locationRow: 'planner-location-row',
  locationInput: 'planner-location-input',
  locationOption: 'planner-location-option',
  locationClear: 'planner-location-clear',
  locationToggle: 'planner-location-toggle',
  locationSkip: 'planner-location-skip',
  locationChange: 'planner-location-change',
  consentApprove: 'planner-consent-approve',
  consentAlwaysAllow: 'planner-consent-always-allow',
  consentDecline: 'planner-consent-decline',
  enquiryReview: 'planner-enquiry-review',
  enquirySent: 'planner-enquiry-sent',
  heldQuestion: 'planner-held-question',
  heldConfirm: 'planner-held-confirm',
  heldKeep: 'planner-held-keep',
  permissions: 'planner-permissions',
  permissionsReset: 'planner-permissions-reset',
  actionsExpired: 'planner-actions-expired',
  actionsInterruptedMark: 'planner-actions-interrupted-mark',
  feedbackUp: 'planner-feedback-up',
  feedbackDown: 'planner-feedback-down',
  feedbackForm: 'planner-feedback-form',
  feedbackReason: 'planner-feedback-reason',
  feedbackComment: 'planner-feedback-comment',
  feedbackSubmit: 'planner-feedback-submit',
  feedbackHandle: 'planner-feedback-handle',
  daySeparator: 'planner-day-separator',
  searchResults: 'planner-search-results',
  resultCard: 'planner-result-card',
  onboardingExit: 'planner-onboarding-exit',
  coachThinking: 'planner-coach-thinking',
  // The floating button that opens the planner, on mobile and desktop alike.
  fab: 'planner-fab',
} as const;
